var Curriculog = Curriculog || {};

Curriculog.ApiSecret = (function ($, _, Backbone, ApiSecret) {

        ApiSecret = Curriculog.CurriculogModel.extend({
            validate: function(attrs, options) {
                if (attrs.name.length < 1) {
                    return 'Key name is required.';
                }

                // check key name consists of valid characters
                for (var i = 0, n = attrs.name.length; i < n; i++) {
                  var charCode = attrs.name.charCodeAt(i);
                  var validChar = (charCode === 32) // space
                    || (charCode === 45 ) // dash (-)
                    || (charCode === 46)  // period
                    || (charCode >= 48 && charCode <= 59) // 0-9
                    || (charCode >= 65 && charCode <= 90 ) // A-Z
                    || (charCode === 95) // underscore
                    || (charCode >= 97 && charCode <= 122) // a-z;

                  if ( validChar === false ){
                    return 'Key name may only contain any number of letters ([A-Za-z]), digits ([0-9]), hypens ("-"), underscores ("_"), colons (":"), periods (".") and spaces (" ")';
                  }
                }
            },
        });

        return ApiSecret;

})($, _, Backbone, Curriculog.ApiSecret || {});
